import "../styles/CharacterBlock.css"

function CharacterBlock({ char, state = "normal" }) {
  return <div className={`character-block ${state}`}>{char}</div>
}

export default CharacterBlock


